import { Component, Element, Listen } from '@stencil/core';

window.i18n = window.i18n || {};
const label = window.i18n['clientlibs.more.button'] || 'More';

@Component({
  styleUrls: {
    default: 'igws-breadcrumbs.default.less',
    rtl: 'igws-breadcrumbs.rtl.less',
    rebrand: 'igws-breadcrumbs.default.less',
    rtl_rebrand: 'igws-breadcrumbs.rtl.less',
    prime: 'igws-breadcrumbs.default.less',
    rtl_prime: 'igws-breadcrumbs.rtl.less',
    investments: 'igws-breadcrumbs.default.less',
    rtl_investments: 'igws-breadcrumbs.rtl.less',
    helpandsupport: 'igws-breadcrumbs.default.less',
    rtl_helpandsupport: 'igws-breadcrumbs.rtl.less',
    academy: 'igws-breadcrumbs.default.less',
    rtl_academy: 'igws-breadcrumbs.rtl.less',
    landingpages: 'igws-breadcrumbs.default.less',
    rtl_landingpages: 'igws-breadcrumbs.rtl.less',
    generic: 'igws-breadcrumbs.default.less',
    rtl_generic: 'igws-breadcrumbs.rtl.less',
  },
  tag: 'igws-breadcrumbs',
})
export class BreadcrumbsComponent {
  timeoutID: any;
  selectableItems: any = [];

  @Element() el!: HTMLIgwsBreadcrumbsElement;

  componentDidLoad() {
    const childs = (this.el && (this.el.querySelectorAll('.breadcrumb__child') as NodeListOf<IGHTMLElement>)) || [];
    [...this.selectableItems] = Array.from(childs);
    this.reset();
  }

  @Listen('click', {})
  toggleMoreMenu(event: UIEvent) {
    const element = event && (event.target as IGHTMLElement);
    if (element && element.classList.contains('breadcrumb__more-link')) {
      event.preventDefault();
      const moreDropdown = this.el && this.el.querySelector('.more__menu');
      moreDropdown && moreDropdown.classList.toggle('open');
      element.classList.toggle('open');
    }
  }

  @Listen('resize', { target: 'window' })
  handleScroll() {
    window.clearTimeout(this.timeoutID);
    this.timeoutID = window.setTimeout(() => {
      this.reset();
    }, 100);
  }

  @Listen('click', { target: 'document' })
  handleClick(ev: UIEvent) {
    const moreDropdown = this.el && this.el.querySelector('.more__menu');
    const moreLink = this.el && this.el.querySelector('.breadcrumb__more-link');

    if (ev.target !== this.el && ev.target !== moreDropdown && ev.target !== moreLink) {
      moreDropdown && moreDropdown.classList.remove('open');
      moreLink && moreLink.classList.remove('open');
    }
  }

  reset() {
    this.selectableItems.forEach((item: IGHTMLElement) => (item.inDropDown = false));
    this.renderMoreMenu();
    this.verifyMoreMenu();
    this.moreMenuInViewport();
    this.fixMALinks();
  }

  moreMenuInViewport() {
    const menu = this.el && (this.el.querySelector('.breadcrumb__more') as IGHTMLElement);
    if (menu && !menu.fitsWrapper()) {
      let lastItem = -1;
      this.selectableItems.forEach((item: IGHTMLElement, i: number) => {
        if (!item.inDropDown) {
          lastItem = i;
        }
      });
      if (lastItem !== -1) {
        this.selectableItems[lastItem].inDropDown = true;
        this.renderMoreMenu();
      }
    }
  }

  verifyMoreMenu() {
    const container = this.el && (this.el.querySelector('.breadcrumbs__container') as IGHTMLElement);
    this.selectableItems.forEach((child: IGHTMLElement) => {
      if (container && !child.fitsWrapper(container)) {
        child.inDropDown = true;
      }
    });
    this.renderMoreMenu();
  }

  renderMoreMenu() {
    const container = this.el && (this.el.querySelector('.breadcrumbs__children') as IGHTMLElement);
    const moreMenuDropdown = this.selectableItems.filter((item: IGHTMLElement) => item.inDropDown);
    const moreMenu = this.el && (this.el.querySelector('.more__menu') as IGHTMLElement);

    if (moreMenuDropdown.length === 0 && moreMenu) {
      this.removeMoreMenu(container, moreMenu);
    } else if (moreMenuDropdown.length > 0) {
      if (!moreMenu) {
        this.createMoreMenu(container, moreMenuDropdown);
      } else {
        this.updateMoreMenu(moreMenu, moreMenuDropdown);
      }

      moreMenuDropdown.forEach((element: IGHTMLElement) => {
        const childs = container.querySelectorAll('.breadcrumb__child');
        if (Array.from(childs).includes(element)) {
          container.removeChild(element);
        }
      });
    }
  }

  createMoreMenu(container: IGHTMLElement, moreMenuDropdown: []) {
    const moreMenu = document.createElement('li');
    moreMenu.classList.add('breadcrumb__more');
    moreMenu.innerHTML = `
      <a class="breadcrumb__more-link" href="javascript:void(0);">${label}</a>
      <ul class="more__menu">
        ${moreMenuDropdown
          .map((item: IGHTMLElement) => item.outerHTML.replace('breadcrumb__child', 'more__child'))
          .join('')}
      </ul>
    `;

    container.appendChild(moreMenu);
  }

  updateMoreMenu(moreMenu: IGHTMLElement, moreMenuDropdown: []) {
    moreMenu.innerHTML = `${moreMenuDropdown
      .map((item: IGHTMLElement) => item.outerHTML.replace('breadcrumb__child', 'more__child'))
      .join('')}`;
  }

  removeMoreMenu(container: IGHTMLElement, moreMenu: IGHTMLElement) {
    const childs = (this.el && (this.el.querySelectorAll('.breadcrumb__child') as NodeListOf<IGHTMLElement>)) || [];
    moreMenu.parentElement && container.removeChild(moreMenu.parentElement);
    this.selectableItems
      .filter((item: IGHTMLElement) => !Array.from(childs).includes(item))
      .forEach((element: IGHTMLElement) => container.appendChild(element));
  }

  fixMALinks() {
    const removeBackSlash = (str: string) => str.replace(/\\\//g, '/');
    const fixAccentMarks = (str: string) =>
      str.replace(/\\u[\dA-F]{4}/gi, match => String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16)));

    const lastLink = this.el && this.el.querySelector('.breadcrumb--last > .breadcrumb__link');
    lastLink!.textContent = fixAccentMarks(lastLink!.textContent!);
    lastLink!.textContent = removeBackSlash(lastLink!.textContent!);
  }

  render() {
    return;
  }
}
